export default __webpack_public_path__ + "static/media/ArrowOrangeIcon.e05756d5.svg";